import { useMutation } from "react-query";
import { createApiWithPath } from "../../client";

interface ImageUrlResponse {
  data: {
    url: string;
  };
}

export const useGetImageUrl = () => {
  return useMutation<string, Error, string>(async (path: string) => {
    const response = await createApiWithPath("crm").post<ImageUrlResponse>(
      "/field-values/image-url",
      { path },
    );
    return response.data.data.url;
  });
};
